/**
 * API 根地址
 * 优先级:VITE_API_BASE 环境变量 > 部署域名自动推断 > 空(用 Vite dev proxy)
 *
 * 部署域名推断:
 *  - ai-tiaozs-a.pages.dev / ai-tiaozs-b.pages.dev → ai-tiaozs-api.flybirdai.com
 *  - ai-tiaozs-a.flybirdai.com / ai-tiaozs-b.flybirdai.com → api.flybirdai.com
 *
 * 这样即使 build 时漏了 VITE_API_BASE,线上也不会走相对路径(会被 Pages 兜底成 405)
 */
const PROD_API_BASE = 'https://ai-tiaozs-api.flybirdai.com';

type ImportMetaEnvLite = { VITE_API_BASE?: string };
type ImportMetaLite = { env?: ImportMetaEnvLite };
const meta: ImportMetaLite | undefined =
  typeof import.meta !== 'undefined' ? (import.meta as unknown as ImportMetaLite) : undefined;

function inferFromHost(): string | null {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  if (host.endsWith('.flybirdai.com') || host.endsWith('.pages.dev')) {
    return PROD_API_BASE;
  }
  return null;
}

export function getApiBase(): string {
  // 1) 显式环境变量
  const fromEnv = meta?.env?.VITE_API_BASE ?? '';
  if (fromEnv) return String(fromEnv).replace(/\/$/, '');
  // 2) 部署域名推断
  const fromHost = inferFromHost();
  if (fromHost) return fromHost;
  // 3) dev 模式(Vite 配的 /api proxy)
  return '';
}

export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const base = getApiBase();
  return base ? `${base}${p}` : p;
}
